import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmReportIncidentPopup } from '~/actions';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { RadioOption } from '~/commonComponents';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';
import WarningIcon from '~/images/warning-icon.svg';
import { incidentTypes } from '../utils/incidentPopupUtil';
import { NumberUtils } from '~/utils/NumberUtils';

export const ConfirmationSelectIncident = ({ onClose }) => {
  const dispatch = useDispatch();
  const [incidentType, setIncidentType] = useState(null);

  return (
    <ConfirmPopupContent
      Icon={() => <img src={WarningIcon} style={{ marginBottom: 20 }} alt="warning_icon" data-cy="incident-warning-icon" />}
      title="Report An Incident"
      description={
        <div data-cy="select-incident-type-content">
          <Typography as="span" textAlign="center" data-cy="incident-prompt-text">What type of incident would you like to report?</Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              marginTop: 20,
              marginBottom: 20,
            }}
            data-cy="incident-type-options"
          >
            <RadioOption
              textStyle={{ color: colors.neutral[500] }}
              onClick={() => setIncidentType(incidentTypes.noShow)}
              text="No-Show"
              checked={incidentType === incidentTypes.noShow}
              dataCy="incident-type-no-show"
            />
            <RadioOption
              textStyle={{ color: colors.neutral[500] }}
              onClick={() => setIncidentType(incidentTypes.walkedOut)}
              text="Walked-Out"
              checked={incidentType === incidentTypes.walkedOut}
              dataCy="incident-type-walked-out"
            />
          </div>
          <Typography as="span" textAlign="center" data-cy="incident-support-text">
            If the incident doesn&apos;t fall into these two categories, please call or text our
            Customer Support at {NumberUtils.getCSPhone().formattedSimplified}, and they will be able to assist you.
          </Typography>
        </div>
      }
      leftButtonAction={onClose}
      leftButtonText="Go Back"
      leftButtonDataCy="incident-go-back-button"
      rightButtonAction={() => {
        dispatch(showConfirmReportIncidentPopup({ incidentType }));
      }}
      rightButtonDisabled={!incidentType}
      rightButtonText="Continue"
      rightButtonDataCy="incident-continue-button"
      data-cy="select-incident-modal"
    />
  );
};
